import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import {
  API_AUDIO_CHAT,
  API_CHAPTERS_TNPSC,
  API_SUBJECTS,
  API_VIDEO_CHAT,
  apiMyAssestsTnpsc,
  apiHideTnpsc,
  apiUnHideTnpsc,
  API_MEDIUM_TNPSC,
  apiStudentStudys,
  apiMyAssestsTn,
} from "../../utils/api-routes";

const STATUS = [
  { key: "ready", value: "Ready" },
  { key: "generating", value: "Generating" },
  // { key: "failed", value: "Failed" },
];
const LANGUAGES = [
  { key: "Tamil", value: "Tamil" },
  { key: "English", value: "English" },
];
const SORT = [
  { key: "recent", value: "Recent" },
  { key: "oldest", value: "Oldest" },
];

const useHandler = () => {
  const { get, post, put } = useApi();
  const navigate = useNavigate();
  const { mail, user, medium, role } = useSingleton();
  const [apiAssets, setApiAssets] = useState([]);
  const [popupMedia, setPopupMedia] = useState(null);
  const [showAskBox, setShowAskBox] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [audioRes, setAudioRes] = useState({});
  const [videoRes, setVideoRes] = useState({});
  const [classdetails, setClassDetails] = useState({});
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");

  const inputRef = useRef(null);
  const [filters, setFilters] = useState({
    type: "all",
    status: "",
    language: "",
    sort: "recent",
    subject: "",
    chapter: "",
    include_hidden: false,
    dateMode: "specific",
    on_date: "",
    from_date: "",
    to_date: "",
  });
  const audioRef = useRef(null);
  const videoRef = useRef(null);

  const myAssetsApiWithFilters = async (currentFilters) => {
    setApiAssets([]);
    try {
      const res = await get(
        apiMyAssestsTn(
          mail,
          currentFilters.type,
          currentFilters.status,
          currentFilters.language,
          currentFilters.sort,
          currentFilters.subject,
          currentFilters.chapter,
          currentFilters.include_hidden || undefined,
          currentFilters.dateMode === "specific"
            ? currentFilters.on_date
            : undefined,
          currentFilters.dateMode === "range"
            ? currentFilters.from_date
            : undefined,
          currentFilters.dateMode === "range"
            ? currentFilters.to_date
            : undefined,
        ),
      );
      if (res) {
        setApiAssets(res?.data?.assets || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM MYASSESTS WITH FILTERS", e);
    }
  };

  useEffect(() => {
    if (!mail) return;
    myAssetsApiWithFilters(filters);
  }, [filters]);

  const toggleHideAsset = async (asset_id, isHidden) => {
    try {
      if (isHidden) {
        await put(apiUnHideTnpsc(asset_id)); // Unhide
      } else {
        await put(apiHideTnpsc(asset_id)); // Hide
      }

      // Refresh asset list after update
      myAssetsApiWithFilters(filters);
    } catch (e) {
      console.log("Error toggling hide asset", e);
    }
  };

  const aiAudioChat = async (filters, audio_content) => {
    const payload = {
      //  Audio_content: audio_content,
      Audio_content: audio_content,
      language: audio_content?.language,
      Question: question,
    };

    try {
      const res = await post(API_AUDIO_CHAT, payload);
      if (res) {
        setAudioRes(res?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM AUDIO CHAT API", e);
    }
  };

  const aiVideoChat = async (video_content) => {
    const payload = {
      // Video_content: video_content,
      language: video_content?.language,
      filters: video_content,
      Question: question,
    };

    try {
      const res = await post(API_VIDEO_CHAT, payload);
      if (res) {
        setVideoRes(res?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM AI VIDEO CHAT API", e);
    }
  };

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res) {
        // console.log(res?.data)
        setClassDetails(res?.data);
        const payload = {
          board: res?.data?.data?.board,
          clas: res?.data?.data?.class,
        };
        getMediumDetails(payload);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      console.log("Error on getting user studiesdetails", e);
    }
  };

  const getMediumDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MEDIUM_TNPSC, payload);
      if (res) {
        setMediums(res?.data?.mediums);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  const getSubjectDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_SUBJECTS, payload);
      if (res) {
        setSubjects(res?.data?.subjects);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getChapterDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_CHAPTERS_TNPSC, payload);
      if (res) {
        setChapters(res?.data?.chapters);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting chapeter details", e);
    }
  };

  useEffect(() => {
    if (!medium || !classdetails?.data?.class) return;
    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      medium: medium,
    };

    getSubjectDetails(payload);
  }, [medium, classdetails?.data?.class]);

  useEffect(() => {
    if (!selectedSubject || !user?.data?.class) return;

    const payload = {
      //  board:"NCERT",
      board: user?.data?.board,
      clas: user?.data?.class,
      subject: selectedSubject,
      medium: medium,
    };
    getChapterDetails(payload);
  }, [selectedSubject]);

  return {
    SORT,
    STATUS,
    mail,
    apiAssets,
    question,
    showAskBox,
    popupMedia,
    filters,
    audioRef,
    videoRef,
    audioRes,
    videoRes,
    inputRef,
    subjects,
    chapters,
    mediums,
    selectedMedium,
    role,
    setSelectedSubject,
    setPopupMedia,
    setShowAskBox,
    setApiAssets,
    setQuestion,
    setFilters,
    setMediums,
    setSelectedMedium,
    navigate,
    aiVideoChat,
    aiAudioChat,
    toggleHideAsset,
    LANGUAGES,
  };
};

export default useHandler;
